// EXTERNAL_* presence is not the stack mode signal; that remains SELF_HOSTED_SINGLE_TENANT.
function externalEnv(name: string): string | undefined {
  const value = process.env[name]?.trim();
  return value || undefined;
}

export function optionalExternalUiUrl(): string | undefined {
  return externalEnv("EXTERNAL_UI_URL");
}

export function optionalExternalApiUrl(): string | undefined {
  return externalEnv("EXTERNAL_API_URL");
}

export function optionalExternalPublicUrl(): string | undefined {
  return externalEnv("EXTERNAL_PUBLIC_URL");
}

function missingRequiredWhenBaseAllowsOmit(opts: {
  base?: string;
  selfHostedSingleTenant: boolean;
  value?: string;
}): boolean {
  const base = opts.base?.trim();
  return (!base || opts.selfHostedSingleTenant) && !opts.value;
}

// Cloud stacks with STACK_BASE_DOMAIN may omit EXTERNAL_UI_URL. Flat stacks and
// self-hosted single-tenant still require it (even if a base is also set).
export function missingRequiredExternalUiUrl(opts: {
  stackBaseDomain?: string;
  selfHostedSingleTenant: boolean;
  externalUiUrl?: string;
}): boolean {
  return missingRequiredWhenBaseAllowsOmit({
    base: opts.stackBaseDomain,
    selfHostedSingleTenant: opts.selfHostedSingleTenant,
    value: opts.externalUiUrl,
  });
}

// Same omit rule as EXTERNAL_UI_URL: STACK_BASE_DOMAIN allows cloud to omit.
export function missingRequiredExternalApiUrl(opts: {
  stackBaseDomain?: string;
  selfHostedSingleTenant: boolean;
  externalApiUrl?: string;
}): boolean {
  return missingRequiredWhenBaseAllowsOmit({
    base: opts.stackBaseDomain,
    selfHostedSingleTenant: opts.selfHostedSingleTenant,
    value: opts.externalApiUrl,
  });
}

// Public URL composition keys off STACK_PUBLIC_BASE_DOMAIN, not STACK_BASE_DOMAIN.
export function missingRequiredExternalPublicUrl(opts: {
  stackPublicBaseDomain?: string;
  selfHostedSingleTenant: boolean;
  externalPublicUrl?: string;
}): boolean {
  return missingRequiredWhenBaseAllowsOmit({
    base: opts.stackPublicBaseDomain,
    selfHostedSingleTenant: opts.selfHostedSingleTenant,
    value: opts.externalPublicUrl,
  });
}

// Prefer EXTERNAL_PUBLIC_URL when present (same as before omit). When it is
// omitted, a configured public or app base means the stack is HTTPS.
export function responseCookiesAreSecure(opts: {
  stackBaseDomain?: string;
  stackPublicBaseDomain?: string;
  externalPublicUrl?: string;
}): boolean {
  if (opts.externalPublicUrl) {
    return new URL(opts.externalPublicUrl).protocol === "https:";
  }
  return Boolean(
    opts.stackPublicBaseDomain?.trim() || opts.stackBaseDomain?.trim()
  );
}
